import React from 'react';
import { Card, CardContent } from './ui/card';
import { Award, Star, BookOpen } from 'lucide-react';
// Props: achievements

const Achievements = ({ achievements }) => {
  if (!achievements) return null;
  const getIcon = (iconName) => {
    const icons = {
      Award: Award,
      Star: Star,
      BookOpen: BookOpen
    };
    const IconComponent = icons[iconName] || Award;
    return <IconComponent className="w-8 h-8 text-blue-900" />;
  };

  return (
    <section id="achievements" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Achievements & Recognition</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Awards and recognitions for academic and extracurricular excellence
          </p>
          <div className="w-20 h-1 bg-blue-900 mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {achievements.map((achievement) => (
            <Card key={achievement.id} className="border-2 border-gray-100 hover:border-blue-200 transition-all hover:shadow-lg">
              <CardContent className="p-6 text-center">
                <div className="mb-4 flex justify-center">
                  <div className="p-4 bg-blue-100 rounded-full">
                    {getIcon(achievement.icon)}
                  </div>
                </div>
                <h3 className="font-bold text-lg text-gray-900 mb-2">{achievement.title}</h3>
                <p className="text-sm text-blue-900 font-medium mb-2">{achievement.organization}</p>
                <p className="text-gray-700 text-sm mb-3">{achievement.description}</p>
                <p className="text-xs text-gray-500">{achievement.date}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Achievements;
